/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getWarning = /* GraphQL */ `query GetWarning($id: ID!) {
  getWarning(id: $id) {
    id
    title
    description
    group
    level
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWarningQueryVariables,
  APITypes.GetWarningQuery
>;
export const listWarnings = /* GraphQL */ `query ListWarnings(
  $filter: ModelWarningFilterInput
  $limit: Int
  $nextToken: String
) {
  listWarnings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      description
      group
      level
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWarningsQueryVariables,
  APITypes.ListWarningsQuery
>;
export const syncWarnings = /* GraphQL */ `query SyncWarnings(
  $filter: ModelWarningFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncWarnings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      title
      description
      group
      level
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncWarningsQueryVariables,
  APITypes.SyncWarningsQuery
>;
export const getGroundWater = /* GraphQL */ `query GetGroundWater($id: ID!) {
  getGroundWater(id: $id) {
    id
    altitude
    center {
      lat
      lon
      __typename
    }
    radius
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGroundWaterQueryVariables,
  APITypes.GetGroundWaterQuery
>;
export const listGroundWaters = /* GraphQL */ `query ListGroundWaters(
  $filter: ModelGroundWaterFilterInput
  $limit: Int
  $nextToken: String
) {
  listGroundWaters(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      altitude
      center {
        lat
        lon
        __typename
      }
      radius
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGroundWatersQueryVariables,
  APITypes.ListGroundWatersQuery
>;
export const syncGroundWaters = /* GraphQL */ `query SyncGroundWaters(
  $filter: ModelGroundWaterFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncGroundWaters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      altitude
      center {
        lat
        lon
        __typename
      }
      radius
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncGroundWatersQueryVariables,
  APITypes.SyncGroundWatersQuery
>;
export const getPlaceReport = /* GraphQL */ `query GetPlaceReport($id: ID!) {
  getPlaceReport(id: $id) {
    owner
    id
    rating
    waterTemp
    visibility
    swell
    wind
    text
    date
    place {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeReportsId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlaceReportQueryVariables,
  APITypes.GetPlaceReportQuery
>;
export const listPlaceReports = /* GraphQL */ `query ListPlaceReports(
  $filter: ModelPlaceReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlaceReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      owner
      id
      rating
      waterTemp
      visibility
      swell
      wind
      text
      date
      place {
        id
        data {
          name
          alternateNames
          location {
            lat
            lon
            __typename
          }
          locationKnown
          checked
          checkedBy
          spelioData {
            systemName
            reference
            source
            type
            notes
            caveRating
            highestCaveRating
            tourismPotential
            accessDetails
            verticalAccess
            explorationPotential
            disabledAccessPotential
            files
            labels
            goesToWater
            surveyedLength
            __typename
          }
          diveData {
            minDepth
            maxDepth
            waterType
            isTidal
            minTemp
            maxTemp
            difficulty
            entryDifficulty
            entryType
            __typename
          }
          wreckData {
            type
            built
            dateSunk
            length
            width
            draught
            __typename
          }
          address {
            streetNumber
            street
            suburb
            state
            country
            postcode
            timezone
            __typename
          }
          altitude
          warnings
          amenities {
            hasShowers
            hasToilets
            hasPhone
            food
            family
            parking
            __typename
          }
          __typename
        }
        userAccess
        groupAccess
        reports {
          items {
            owner
            id
            rating
            waterTemp
            visibility
            swell
            wind
            text
            date
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeReportsId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        ratings {
          items {
            id
            rating
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeRatingsId
            owner
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        media {
          items {
            id
            owner
            groupAccess
            placeMediaId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        softDeleted
        scubaCollection
        caveCollection
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      placeReportsId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlaceReportsQueryVariables,
  APITypes.ListPlaceReportsQuery
>;
export const syncPlaceReports = /* GraphQL */ `query SyncPlaceReports(
  $filter: ModelPlaceReportFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPlaceReports(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      owner
      id
      rating
      waterTemp
      visibility
      swell
      wind
      text
      date
      place {
        id
        data {
          name
          alternateNames
          location {
            lat
            lon
            __typename
          }
          locationKnown
          checked
          checkedBy
          spelioData {
            systemName
            reference
            source
            type
            notes
            caveRating
            highestCaveRating
            tourismPotential
            accessDetails
            verticalAccess
            explorationPotential
            disabledAccessPotential
            files
            labels
            goesToWater
            surveyedLength
            __typename
          }
          diveData {
            minDepth
            maxDepth
            waterType
            isTidal
            minTemp
            maxTemp
            difficulty
            entryDifficulty
            entryType
            __typename
          }
          wreckData {
            type
            built
            dateSunk
            length
            width
            draught
            __typename
          }
          address {
            streetNumber
            street
            suburb
            state
            country
            postcode
            timezone
            __typename
          }
          altitude
          warnings
          amenities {
            hasShowers
            hasToilets
            hasPhone
            food
            family
            parking
            __typename
          }
          __typename
        }
        userAccess
        groupAccess
        reports {
          items {
            owner
            id
            rating
            waterTemp
            visibility
            swell
            wind
            text
            date
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeReportsId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        ratings {
          items {
            id
            rating
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeRatingsId
            owner
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        media {
          items {
            id
            owner
            groupAccess
            placeMediaId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        softDeleted
        scubaCollection
        caveCollection
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      placeReportsId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPlaceReportsQueryVariables,
  APITypes.SyncPlaceReportsQuery
>;
export const getPlaceRating = /* GraphQL */ `query GetPlaceRating($id: ID!) {
  getPlaceRating(id: $id) {
    id
    rating
    place {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeRatingsId
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlaceRatingQueryVariables,
  APITypes.GetPlaceRatingQuery
>;
export const listPlaceRatings = /* GraphQL */ `query ListPlaceRatings(
  $filter: ModelPlaceRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlaceRatings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      rating
      place {
        id
        data {
          name
          alternateNames
          location {
            lat
            lon
            __typename
          }
          locationKnown
          checked
          checkedBy
          spelioData {
            systemName
            reference
            source
            type
            notes
            caveRating
            highestCaveRating
            tourismPotential
            accessDetails
            verticalAccess
            explorationPotential
            disabledAccessPotential
            files
            labels
            goesToWater
            surveyedLength
            __typename
          }
          diveData {
            minDepth
            maxDepth
            waterType
            isTidal
            minTemp
            maxTemp
            difficulty
            entryDifficulty
            entryType
            __typename
          }
          wreckData {
            type
            built
            dateSunk
            length
            width
            draught
            __typename
          }
          address {
            streetNumber
            street
            suburb
            state
            country
            postcode
            timezone
            __typename
          }
          altitude
          warnings
          amenities {
            hasShowers
            hasToilets
            hasPhone
            food
            family
            parking
            __typename
          }
          __typename
        }
        userAccess
        groupAccess
        reports {
          items {
            owner
            id
            rating
            waterTemp
            visibility
            swell
            wind
            text
            date
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeReportsId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        ratings {
          items {
            id
            rating
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeRatingsId
            owner
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        media {
          items {
            id
            owner
            groupAccess
            placeMediaId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        softDeleted
        scubaCollection
        caveCollection
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      placeRatingsId
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlaceRatingsQueryVariables,
  APITypes.ListPlaceRatingsQuery
>;
export const syncPlaceRatings = /* GraphQL */ `query SyncPlaceRatings(
  $filter: ModelPlaceRatingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPlaceRatings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      rating
      place {
        id
        data {
          name
          alternateNames
          location {
            lat
            lon
            __typename
          }
          locationKnown
          checked
          checkedBy
          spelioData {
            systemName
            reference
            source
            type
            notes
            caveRating
            highestCaveRating
            tourismPotential
            accessDetails
            verticalAccess
            explorationPotential
            disabledAccessPotential
            files
            labels
            goesToWater
            surveyedLength
            __typename
          }
          diveData {
            minDepth
            maxDepth
            waterType
            isTidal
            minTemp
            maxTemp
            difficulty
            entryDifficulty
            entryType
            __typename
          }
          wreckData {
            type
            built
            dateSunk
            length
            width
            draught
            __typename
          }
          address {
            streetNumber
            street
            suburb
            state
            country
            postcode
            timezone
            __typename
          }
          altitude
          warnings
          amenities {
            hasShowers
            hasToilets
            hasPhone
            food
            family
            parking
            __typename
          }
          __typename
        }
        userAccess
        groupAccess
        reports {
          items {
            owner
            id
            rating
            waterTemp
            visibility
            swell
            wind
            text
            date
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeReportsId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        ratings {
          items {
            id
            rating
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeRatingsId
            owner
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        media {
          items {
            id
            owner
            groupAccess
            placeMediaId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        softDeleted
        scubaCollection
        caveCollection
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      placeRatingsId
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPlaceRatingsQueryVariables,
  APITypes.SyncPlaceRatingsQuery
>;
export const getPlaceMediaItem = /* GraphQL */ `query GetPlaceMediaItem($id: ID!) {
  getPlaceMediaItem(id: $id) {
    id
    owner
    groupAccess
    media {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    placeMediaId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlaceMediaItemQueryVariables,
  APITypes.GetPlaceMediaItemQuery
>;
export const listPlaceMediaItems = /* GraphQL */ `query ListPlaceMediaItems(
  $filter: ModelPlaceMediaItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlaceMediaItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      groupAccess
      media {
        id
        contributorId
        mimeType
        file {
          bucket
          region
          key
          __typename
        }
        thumbnail_256px {
          bucket
          region
          key
          __typename
        }
        thumbnail_512px {
          bucket
          region
          key
          __typename
        }
        thumbnail_1024px {
          bucket
          region
          key
          __typename
        }
        name
        description
        contentType
        attribution
        attributionLink
        dateAdded
        dateCreated
        __typename
      }
      placeMediaId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlaceMediaItemsQueryVariables,
  APITypes.ListPlaceMediaItemsQuery
>;
export const syncPlaceMediaItems = /* GraphQL */ `query SyncPlaceMediaItems(
  $filter: ModelPlaceMediaItemFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPlaceMediaItems(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      owner
      groupAccess
      media {
        id
        contributorId
        mimeType
        file {
          bucket
          region
          key
          __typename
        }
        thumbnail_256px {
          bucket
          region
          key
          __typename
        }
        thumbnail_512px {
          bucket
          region
          key
          __typename
        }
        thumbnail_1024px {
          bucket
          region
          key
          __typename
        }
        name
        description
        contentType
        attribution
        attributionLink
        dateAdded
        dateCreated
        __typename
      }
      placeMediaId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPlaceMediaItemsQueryVariables,
  APITypes.SyncPlaceMediaItemsQuery
>;
export const getPlace = /* GraphQL */ `query GetPlace($id: ID!) {
  getPlace(id: $id) {
    id
    data {
      name
      alternateNames
      location {
        lat
        lon
        __typename
      }
      locationKnown
      checked
      checkedBy
      spelioData {
        systemName
        reference
        source
        type
        notes
        caveRating
        highestCaveRating
        tourismPotential
        accessDetails
        verticalAccess
        explorationPotential
        disabledAccessPotential
        files
        labels
        goesToWater
        references {
          name
          text
          __typename
        }
        surveyedLength
        __typename
      }
      diveData {
        minDepth
        maxDepth
        waterType
        isTidal
        minTemp
        maxTemp
        difficulty
        entryDifficulty
        entryType
        __typename
      }
      wreckData {
        type
        built
        dateSunk
        length
        width
        draught
        __typename
      }
      address {
        streetNumber
        street
        suburb
        state
        country
        postcode
        timezone
        __typename
      }
      altitude
      warnings
      amenities {
        hasShowers
        hasToilets
        hasPhone
        food
        family
        parking
        __typename
      }
      __typename
    }
    userAccess
    groupAccess
    reports {
      items {
        owner
        id
        rating
        waterTemp
        visibility
        swell
        wind
        text
        date
        place {
          id
          data {
            name
            alternateNames
            locationKnown
            checked
            checkedBy
            altitude
            warnings
            __typename
          }
          userAccess
          groupAccess
          reports {
            nextToken
            startedAt
            __typename
          }
          ratings {
            nextToken
            startedAt
            __typename
          }
          media {
            nextToken
            startedAt
            __typename
          }
          softDeleted
          scubaCollection
          caveCollection
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeReportsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    ratings {
      items {
        id
        rating
        place {
          id
          data {
            name
            alternateNames
            locationKnown
            checked
            checkedBy
            altitude
            warnings
            __typename
          }
          userAccess
          groupAccess
          reports {
            nextToken
            startedAt
            __typename
          }
          ratings {
            nextToken
            startedAt
            __typename
          }
          media {
            nextToken
            startedAt
            __typename
          }
          softDeleted
          scubaCollection
          caveCollection
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeRatingsId
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    media {
      items {
        id
        owner
        groupAccess
        media {
          id
          contributorId
          mimeType
          file {
            bucket
            region
            key
            __typename
          }
          thumbnail_256px {
            bucket
            region
            key
            __typename
          }
          thumbnail_512px {
            bucket
            region
            key
            __typename
          }
          thumbnail_1024px {
            bucket
            region
            key
            __typename
          }
          name
          description
          contentType
          attribution
          attributionLink
          dateAdded
          dateCreated
          __typename
        }
        placeMediaId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    softDeleted
    scubaCollection
    caveCollection
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPlaceQueryVariables, APITypes.GetPlaceQuery>;
export const listPlaces = /* GraphQL */ `query ListPlaces(
  $filter: ModelPlaceFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlaces(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlacesQueryVariables,
  APITypes.ListPlacesQuery
>;
export const syncPlaces = /* GraphQL */ `query SyncPlaces(
  $filter: ModelPlaceFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPlaces(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPlacesQueryVariables,
  APITypes.SyncPlacesQuery
>;
export const placeBySoftDeleted = /* GraphQL */ `query PlaceBySoftDeleted(
  $softDeleted: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPlaceFilterInput
  $limit: Int
  $nextToken: String
) {
  placeBySoftDeleted(
    softDeleted: $softDeleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlaceBySoftDeletedQueryVariables,
  APITypes.PlaceBySoftDeletedQuery
>;
export const placeByScubaCollection = /* GraphQL */ `query PlaceByScubaCollection(
  $scubaCollection: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPlaceFilterInput
  $limit: Int
  $nextToken: String
) {
  placeByScubaCollection(
    scubaCollection: $scubaCollection
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlaceByScubaCollectionQueryVariables,
  APITypes.PlaceByScubaCollectionQuery
>;
export const placeByCaveCollection = /* GraphQL */ `query PlaceByCaveCollection(
  $caveCollection: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPlaceFilterInput
  $limit: Int
  $nextToken: String
) {
  placeByCaveCollection(
    caveCollection: $caveCollection
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlaceByCaveCollectionQueryVariables,
  APITypes.PlaceByCaveCollectionQuery
>;
export const getJournal = /* GraphQL */ `query GetJournal($id: ID!) {
  getJournal(id: $id) {
    id
    addedAt
    scubaCollection
    caveCollection
    modifications {
      action
      model
      modelId
      modelName
      detail
      collections
      __typename
    }
    modification {
      action
      model
      modelId
      modelName
      detail
      collections
      __typename
    }
    userAccess
    groupAccess
    contributor
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetJournalQueryVariables,
  APITypes.GetJournalQuery
>;
export const listJournals = /* GraphQL */ `query ListJournals(
  $filter: ModelJournalFilterInput
  $limit: Int
  $nextToken: String
) {
  listJournals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      addedAt
      scubaCollection
      caveCollection
      modifications {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      modification {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      userAccess
      groupAccess
      contributor
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListJournalsQueryVariables,
  APITypes.ListJournalsQuery
>;
export const syncJournals = /* GraphQL */ `query SyncJournals(
  $filter: ModelJournalFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncJournals(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      addedAt
      scubaCollection
      caveCollection
      modifications {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      modification {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      userAccess
      groupAccess
      contributor
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncJournalsQueryVariables,
  APITypes.SyncJournalsQuery
>;
export const journalByAddedAt = /* GraphQL */ `query JournalByAddedAt(
  $addedAt: AWSDateTime!
  $sortDirection: ModelSortDirection
  $filter: ModelJournalFilterInput
  $limit: Int
  $nextToken: String
) {
  journalByAddedAt(
    addedAt: $addedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      addedAt
      scubaCollection
      caveCollection
      modifications {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      modification {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      userAccess
      groupAccess
      contributor
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JournalByAddedAtQueryVariables,
  APITypes.JournalByAddedAtQuery
>;
export const journalByScubaCollection = /* GraphQL */ `query JournalByScubaCollection(
  $scubaCollection: String!
  $sortDirection: ModelSortDirection
  $filter: ModelJournalFilterInput
  $limit: Int
  $nextToken: String
) {
  journalByScubaCollection(
    scubaCollection: $scubaCollection
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      addedAt
      scubaCollection
      caveCollection
      modifications {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      modification {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      userAccess
      groupAccess
      contributor
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JournalByScubaCollectionQueryVariables,
  APITypes.JournalByScubaCollectionQuery
>;
export const journalByCaveCollection = /* GraphQL */ `query JournalByCaveCollection(
  $caveCollection: String!
  $sortDirection: ModelSortDirection
  $filter: ModelJournalFilterInput
  $limit: Int
  $nextToken: String
) {
  journalByCaveCollection(
    caveCollection: $caveCollection
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      addedAt
      scubaCollection
      caveCollection
      modifications {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      modification {
        action
        model
        modelId
        modelName
        detail
        collections
        __typename
      }
      userAccess
      groupAccess
      contributor
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JournalByCaveCollectionQueryVariables,
  APITypes.JournalByCaveCollectionQuery
>;
export const getUserInfo = /* GraphQL */ `query GetUserInfo($id: ID!) {
  getUserInfo(id: $id) {
    id
    avatar {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    banner {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    displayName
    navigationAccuracy
    displayUnits
    socials {
      website
      facebook
      x
      blueSky
      instagram
      __typename
    }
    isTestAccount
    bio
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserInfoQueryVariables,
  APITypes.GetUserInfoQuery
>;
export const listUserInfos = /* GraphQL */ `query ListUserInfos(
  $filter: ModelUserInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      avatar {
        id
        contributorId
        mimeType
        file {
          bucket
          region
          key
          __typename
        }
        thumbnail_256px {
          bucket
          region
          key
          __typename
        }
        thumbnail_512px {
          bucket
          region
          key
          __typename
        }
        thumbnail_1024px {
          bucket
          region
          key
          __typename
        }
        name
        description
        contentType
        attribution
        attributionLink
        dateAdded
        dateCreated
        __typename
      }
      banner {
        id
        contributorId
        mimeType
        file {
          bucket
          region
          key
          __typename
        }
        thumbnail_256px {
          bucket
          region
          key
          __typename
        }
        thumbnail_512px {
          bucket
          region
          key
          __typename
        }
        thumbnail_1024px {
          bucket
          region
          key
          __typename
        }
        name
        description
        contentType
        attribution
        attributionLink
        dateAdded
        dateCreated
        __typename
      }
      displayName
      navigationAccuracy
      displayUnits
      socials {
        website
        facebook
        x
        blueSky
        instagram
        __typename
      }
      isTestAccount
      bio
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserInfosQueryVariables,
  APITypes.ListUserInfosQuery
>;
export const syncUserInfos = /* GraphQL */ `query SyncUserInfos(
  $filter: ModelUserInfoFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserInfos(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      avatar {
        id
        contributorId
        mimeType
        file {
          bucket
          region
          key
          __typename
        }
        thumbnail_256px {
          bucket
          region
          key
          __typename
        }
        thumbnail_512px {
          bucket
          region
          key
          __typename
        }
        thumbnail_1024px {
          bucket
          region
          key
          __typename
        }
        name
        description
        contentType
        attribution
        attributionLink
        dateAdded
        dateCreated
        __typename
      }
      banner {
        id
        contributorId
        mimeType
        file {
          bucket
          region
          key
          __typename
        }
        thumbnail_256px {
          bucket
          region
          key
          __typename
        }
        thumbnail_512px {
          bucket
          region
          key
          __typename
        }
        thumbnail_1024px {
          bucket
          region
          key
          __typename
        }
        name
        description
        contentType
        attribution
        attributionLink
        dateAdded
        dateCreated
        __typename
      }
      displayName
      navigationAccuracy
      displayUnits
      socials {
        website
        facebook
        x
        blueSky
        instagram
        __typename
      }
      isTestAccount
      bio
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserInfosQueryVariables,
  APITypes.SyncUserInfosQuery
>;
export const userInfoByOwner = /* GraphQL */ `query UserInfoByOwner(
  $owner: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  userInfoByOwner(
    owner: $owner
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      avatar {
        id
        contributorId
        mimeType
        file {
          bucket
          region
          key
          __typename
        }
        thumbnail_256px {
          bucket
          region
          key
          __typename
        }
        thumbnail_512px {
          bucket
          region
          key
          __typename
        }
        thumbnail_1024px {
          bucket
          region
          key
          __typename
        }
        name
        description
        contentType
        attribution
        attributionLink
        dateAdded
        dateCreated
        __typename
      }
      banner {
        id
        contributorId
        mimeType
        file {
          bucket
          region
          key
          __typename
        }
        thumbnail_256px {
          bucket
          region
          key
          __typename
        }
        thumbnail_512px {
          bucket
          region
          key
          __typename
        }
        thumbnail_1024px {
          bucket
          region
          key
          __typename
        }
        name
        description
        contentType
        attribution
        attributionLink
        dateAdded
        dateCreated
        __typename
      }
      displayName
      navigationAccuracy
      displayUnits
      socials {
        website
        facebook
        x
        blueSky
        instagram
        __typename
      }
      isTestAccount
      bio
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserInfoByOwnerQueryVariables,
  APITypes.UserInfoByOwnerQuery
>;
export const getUserFilter = /* GraphQL */ `query GetUserFilter($id: ID!) {
  getUserFilter(id: $id) {
    id
    name
    filterVersion
    filter
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserFilterQueryVariables,
  APITypes.GetUserFilterQuery
>;
export const listUserFilters = /* GraphQL */ `query ListUserFilters(
  $filter: ModelUserFilterFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserFilters(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      filterVersion
      filter
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserFiltersQueryVariables,
  APITypes.ListUserFiltersQuery
>;
export const syncUserFilters = /* GraphQL */ `query SyncUserFilters(
  $filter: ModelUserFilterFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserFilters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      filterVersion
      filter
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserFiltersQueryVariables,
  APITypes.SyncUserFiltersQuery
>;
export const getPublicFilter = /* GraphQL */ `query GetPublicFilter($id: ID!) {
  getPublicFilter(id: $id) {
    id
    name
    filterVersion
    filter
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPublicFilterQueryVariables,
  APITypes.GetPublicFilterQuery
>;
export const listPublicFilters = /* GraphQL */ `query ListPublicFilters(
  $filter: ModelPublicFilterFilterInput
  $limit: Int
  $nextToken: String
) {
  listPublicFilters(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      filterVersion
      filter
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPublicFiltersQueryVariables,
  APITypes.ListPublicFiltersQuery
>;
export const syncPublicFilters = /* GraphQL */ `query SyncPublicFilters(
  $filter: ModelPublicFilterFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPublicFilters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      filterVersion
      filter
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPublicFiltersQueryVariables,
  APITypes.SyncPublicFiltersQuery
>;
export const getModerationRequest = /* GraphQL */ `query GetModerationRequest($id: ID!) {
  getModerationRequest(id: $id) {
    id
    anonymous
    payload
    type
    status
    groupAccess
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetModerationRequestQueryVariables,
  APITypes.GetModerationRequestQuery
>;
export const listModerationRequests = /* GraphQL */ `query ListModerationRequests(
  $filter: ModelModerationRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  listModerationRequests(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      anonymous
      payload
      type
      status
      groupAccess
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListModerationRequestsQueryVariables,
  APITypes.ListModerationRequestsQuery
>;
export const syncModerationRequests = /* GraphQL */ `query SyncModerationRequests(
  $filter: ModelModerationRequestFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncModerationRequests(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      anonymous
      payload
      type
      status
      groupAccess
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncModerationRequestsQueryVariables,
  APITypes.SyncModerationRequestsQuery
>;
export const getPlaceListEntry = /* GraphQL */ `query GetPlaceListEntry($id: ID!) {
  getPlaceListEntry(id: $id) {
    id
    placeList {
      id
      name
      description
      entries {
        items {
          id
          placeList {
            id
            name
            description
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
            __typename
          }
          place
          order
          checked
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeListEntriesId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    place
    order
    checked
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeListEntriesId
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlaceListEntryQueryVariables,
  APITypes.GetPlaceListEntryQuery
>;
export const listPlaceListEntries = /* GraphQL */ `query ListPlaceListEntries(
  $filter: ModelPlaceListEntryFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlaceListEntries(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      placeList {
        id
        name
        description
        entries {
          items {
            id
            place
            order
            checked
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeListEntriesId
            owner
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      place
      order
      checked
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      placeListEntriesId
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlaceListEntriesQueryVariables,
  APITypes.ListPlaceListEntriesQuery
>;
export const syncPlaceListEntries = /* GraphQL */ `query SyncPlaceListEntries(
  $filter: ModelPlaceListEntryFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPlaceListEntries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      placeList {
        id
        name
        description
        entries {
          items {
            id
            place
            order
            checked
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            placeListEntriesId
            owner
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      place
      order
      checked
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      placeListEntriesId
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPlaceListEntriesQueryVariables,
  APITypes.SyncPlaceListEntriesQuery
>;
export const getPlaceList = /* GraphQL */ `query GetPlaceList($id: ID!) {
  getPlaceList(id: $id) {
    id
    name
    description
    entries {
      items {
        id
        placeList {
          id
          name
          description
          entries {
            nextToken
            startedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        place
        order
        checked
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeListEntriesId
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlaceListQueryVariables,
  APITypes.GetPlaceListQuery
>;
export const listPlaceLists = /* GraphQL */ `query ListPlaceLists(
  $filter: ModelPlaceListFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlaceLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      entries {
        items {
          id
          placeList {
            id
            name
            description
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
            __typename
          }
          place
          order
          checked
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeListEntriesId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlaceListsQueryVariables,
  APITypes.ListPlaceListsQuery
>;
export const syncPlaceLists = /* GraphQL */ `query SyncPlaceLists(
  $filter: ModelPlaceListFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPlaceLists(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      entries {
        items {
          id
          placeList {
            id
            name
            description
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
            __typename
          }
          place
          order
          checked
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeListEntriesId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPlaceListsQueryVariables,
  APITypes.SyncPlaceListsQuery
>;
